

























































































































































































import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import {
  ActiveSurveyForm,
  SatisfactionSurveyActiveForm,
  SurveyOverviewDetails,
} from "@/api";
import { dateFormat } from "@/common/date_format";
import Loading from "@/components/loader/loading.vue";
import OverviewCard from "@/components/card/OverviewCard.vue";
import StartSurvey from "@/views/survey/overview/StartSurvey.vue";
import OptionsSurvey from "@/views/survey/form/OptionsSurvey.vue";

@Component({
  components: {
    Loading,
    OverviewCard,
    StartSurvey,
    OptionsSurvey,
  },
})
export default class Overview extends Vue {
  loading = false;
  surveyOptionDialog = false;

  startDate = moment()
    .startOf("week")
    .format("YYYY-MM-DD");
  endDate = moment()
    .endOf("week")
    .format("YYYY-MM-DD");
  formErrors = "";
  showStartDate = false;
  showEndDate = false;
  filtering = false;
  dispatchType = "admission";
  currentTab = "admission";
  dischargeForm!: ActiveSurveyForm;
  admissionForm!: ActiveSurveyForm;
  satisfactionForm!: SatisfactionSurveyActiveForm;
  types = ["admission", "discharge", "satisfaction"];

  async created() {
    this.loading = true;
    const dispatchType = this.$route.query.dispatchType;
    if (dispatchType) {
      this.dispatchType = dispatchType.toString() || "admission";
    }
    await this.setfilterDate();
    const payload = this.getPayload();
    const activeForm = this.$store.dispatch(
      "survey/fetchActiveSurveyForm",
      true,
    );
    const overview = this.$store.dispatch("survey/fetchOverview", payload);
    await Promise.all([activeForm, overview]);
    this.loading = false;
  }

  get formattedStartDate() {
    if (this.startDate) {
      this.formatDate(true);
      return dateFormat(this.startDate);
    }
    return "";
  }
  get formattedEndDate() {
    if (this.endDate) {
      this.formatDate(false);
      return dateFormat(this.endDate);
    }
    return "";
  }

  get overviewDetails() {
    let toFetch = "";
    switch (this.dispatchType) {
      case "admission":
        toFetch = "survey/admissionOverview";
        break;
      case "discharge":
        toFetch = "survey/dischargeOverview";
        break;
      case "satisfaction":
        toFetch = "survey/satisfactionOverview";
        break;
    }
    const report = this.$store.getters[toFetch] as SurveyOverviewDetails;
    return report;
  }

  get activeForm() {
    this.dischargeForm = this.$store.getters[
      "survey/activeDischargeForm"
    ] as ActiveSurveyForm;
    this.admissionForm = this.$store.getters[
      "survey/activeAdmissionForm"
    ] as ActiveSurveyForm;
    this.satisfactionForm = this.$store.getters[
      "survey/activeSatisfactionForm"
    ] as SatisfactionSurveyActiveForm;
    switch (this.dispatchType) {
      case "discharge":
        return this.dischargeForm ? true : false;
      case "satisfaction":
        return this.satisfactionForm ? true : false;
      default:
        return this.admissionForm ? true : false;
    }
  }

  async setfilterDate() {
    const beginAt = await this.$store.getters["survey/beginAt"];
    const endAt = await this.$store.getters["survey/endAt"];
    if (endAt && beginAt) {
      this.startDate = beginAt;
      this.endDate = endAt;
    } else {
      this.startDate = moment()
        .startOf("week")
        .format("YYYY-MM-DD");
      this.endDate = moment()
        .endOf("week")
        .format("YYYY-MM-DD");
    }
    if (this.startDate) this.formatDate(true);
    if (this.endDate) this.formatDate(false);
  }

  formatDate(isStartDate: boolean) {
    if (isStartDate) {
      this.$store.dispatch("survey/setBeginAt", this.startDate);
    } else {
      this.$store.dispatch("survey/setEndAt", this.endDate);
    }
  }

  async selectedDate() {
    if (this.startDate && this.endDate) {
      const payload = this.getPayload();

      if (this.startDate < this.endDate) {
        this.formErrors = "";
        this.filtering = true;
        await this.$store.dispatch("survey/fetchOverview", payload);
        this.filtering = false;
      } else {
        this.formErrors = "start date should not be greater than end date";
      }
    }
  }

  getPayload() {
    return {
      beginAt: this.startDate,
      endAt: this.endDate,
      dispatchType: this.dispatchType,
    };
  }

  async clearFilter() {
    this.startDate = moment()
      .startOf("week")
      .format("YYYY-MM-DD");
    this.endDate = moment()
      .endOf("week")
      .format("YYYY-MM-DD");
    this.formErrors = "";
    this.filtering = true;
    this.$store.dispatch("survey/setBeginAt");
    this.$store.dispatch("survey/setEndAt");
    const payload = this.getPayload();
    await this.$store.dispatch("survey/fetchOverview", payload);
    this.filtering = false;
  }

  goTo(title: string, overviewId?: string) {
    this.$router.push({
      path: `/survey/overview/details`,
      query: {
        dispatchType: this.dispatchType,
        beginAt: this.startDate,
        endAt: this.endDate,
        title,
        overviewId,
      },
    });
  }

  destroyed() {
    if (!this.$route.path.includes("overview")) {
      this.$store.dispatch("survey/setBeginAt");
      this.$store.dispatch("survey/setEndAt");
    }
  }

  getAverage(actual: number, total: number) {
    const avg = actual / total;
    if (isNaN(avg)) {
      return 0;
    }
    return avg.toFixed(1); // keeps 2 decimal places
  }

  complete(dispatch: string) {
    this.dispatchType = dispatch;
    this.clearFilter();
  }

  createSurveyForm(to: string) {
    this.$router.push({
      path: `/survey/${to}/form`,
    });
    this.surveyOptionDialog = !this.surveyOptionDialog;
  }

  updateDispatchType(type: string) {
    this.dispatchType = type;
    this.clearFilter();
  }
}
